const INITIAL_STATE = {
  widgetSchoolSections: true
}

const SET_WIDGET_SCHOOL_SECTIONS_LOADING = 'SET_WIDGET_SCHOOL_SECTIONS_LOADING'

const getWidgetSchoolSectionsLoading = state => {
  return state.widgetSchoolSections
}

const setWidgetSchoolSectionsLoading = status => {
  return {
    type: SET_WIDGET_SCHOOL_SECTIONS_LOADING,
    payload: status
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_WIDGET_SCHOOL_SECTIONS_LOADING: {
      return { ...state, widgetSchoolSections: action.payload }
    }
    default:
      return state
  }
}

export {
  getWidgetSchoolSectionsLoading,
  setWidgetSchoolSectionsLoading
}
